import { NavLink } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { useAccessRequestStore } from '@/stores/accessRequestStore';
import { useMessageStore } from '@/stores/messageStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { getMainNavigationItems } from './navigation';

export function BottomNavigation() {
  const { userData } = useAuthStore();
  const unreadTotal = useMessageStore((state) =>
    state.conversations.reduce((sum, conversation) => sum + Math.max(0, conversation.unreadCount), 0)
  );
  const unreadVerificationResultCount = useNotificationStore(
    (state) => state.unreadVerificationResultCount
  );
  const accessRequests = useAccessRequestStore((state) => state.requests);
  const isDonor = userData?.role === 'donor';
  const unreadBadgeText = unreadTotal > 99 ? '99+' : String(unreadTotal);
  const pendingAccessRequestCount = isDonor
    ? accessRequests.filter((request) => request.status === 'pending').length
    : 0;
  const myPageBadgeCount = unreadVerificationResultCount + pendingAccessRequestCount;
  const myPageBadgeText = myPageBadgeCount > 99 ? '99+' : String(myPageBadgeCount);

  const navItems = getMainNavigationItems(isDonor);

  return (
    <nav
      className="flex-shrink-0 border-t border-[#EDEBE6] bg-white"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div
        className="grid h-16"
        style={{ gridTemplateColumns: `repeat(${navItems.length}, minmax(0, 1fr))` }}
      >
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className="flex w-full flex-col items-center justify-center gap-1 py-2 transition-opacity"
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <item.icon
                    size={22}
                    strokeWidth={isActive ? 2.2 : 1.6}
                    color={isActive ? '#B87333' : '#AAAAAA'}
                  />
                  {item.to === '/messages' && unreadTotal > 0 && (
                    <span className="absolute -right-2 -top-2 flex h-[1.15rem] min-w-[1.15rem] items-center justify-center rounded-full bg-copper px-1 text-[10px] font-bold leading-none text-white">
                      {unreadBadgeText}
                    </span>
                  )}
                  {item.to === '/mypage' && myPageBadgeCount > 0 && (
                    <span className="absolute -right-2 -top-2 flex h-[1.15rem] min-w-[1.15rem] items-center justify-center rounded-full bg-copper px-1 text-[10px] font-bold leading-none text-white">
                      {myPageBadgeText}
                    </span>
                  )}
                </div>
                <span
                  className="text-[10px] tracking-wide"
                  style={{ color: isActive ? '#B87333' : '#AAAAAA', fontWeight: isActive ? 600 : 400 }}
                >
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
